<template>
  <div>
    <v-row>
      <v-col v-if="businessRulesGetBoolean('Inventory Classes')" cols="2" class="pb-0">
        <inventory-class-select-element v-model="inventoryClassFilterId" :hideDetails="true"/>
      </v-col>

      <!-- <v-col cols="2">
        <v-select label="Category" v-model="categoryFilterId" hide-details/>
      </v-col> -->

      <v-col cols="3">
        <v-autocomplete
          :label="businessRulesGetBoolean('Jobs Rename to Release') ? 'Release' : 'Job'"
          v-model="jobFilterId"
          :items="jobs"
          hide-details
          item-value="id"
          :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
          clearable
          :loading="loadingJobs"
        >
          <template #selection="{ item }">
            <span>
              <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
            </span>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="2">
        <v-select label="Status" hide-details v-model="statusFilterId" :items="statuses" item-text="name" item-value="id" clearable/>
      </v-col>

      <v-col cols="2">
        <v-switch
          v-model="showArchivedFilter"
          hide-details
          label="Show Archived"
        />
      </v-col>

      <v-col  class="text-right pt-7">
        <v-btn color="primary" outlined @click="openInitForm">
          <v-icon small class="mr-1">
            fas fa-plus
          </v-icon>
          New Allocation
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="tableHeaders"
          :items="allocations"
          :footer-props="footer"
          :items-per-page="pagination.itemsPerPage"
          :search="search"
          :loading="tableIsLoading"
          dense
          fixed-header
          :server-items-length="numberOfAllocations"
          @update:options="updateOptions"
        >
          <template #item="{ item }">
            <tr :style="{ 'background-color': getRowBackgroundColor(item) }" :class="{'grey--text': item.is_archived}">
              <td>{{ item.id }}</td>
              <td class="text-center">
                <v-chip small text-color="white" :color="item.job.class.color">
                  {{ item.job.class.name }}
                </v-chip>
              </td>
              <td>
                <span v-if="item.job">  
                  <span style="font-weight: bold;">
                    <text-highlight :queries="search">{{ item.job.code ? `${item.job.code}` : '' }}</text-highlight>
                  </span>
                  - 
                  <text-highlight :queries="search">{{ item.job.project ? item.job.project.name : '' }}</text-highlight>
                  <span style="color: #1976D2;">
                    <text-highlight :queries="search">{{ item.job.reference ? `; ${item.job.reference}` : '' }}</text-highlight>
                  </span>
                </span>
              </td>
              <td>{{ item.qty_required }}</td>
              <td>{{ item.qty_allocated }}</td>
              <td>{{ item.qty_supplied }}</td>
              <td>{{ item.qty_pre_allocated }}</td>
              <td>{{ item.allocate_by_date }} {{ item.allocate_by_time }}</td>
              <td>{{ formatPercent(item.qty_allocated / item.qty_required) }}</td>
              <td>{{ formatPercent(item.qty_pre_allocated / item.qty_required) }}</td>
              <td>{{ item.user.first_name }} {{ item.user.last_name }}</td>
              <td>{{ item.created_at }}</td>
              <td class="text-center">
                <div v-if="item.status_id in statusMap">
                  <v-chip small :text-color="statusMap[item.status_id].text_color" :color="statusMap[item.status_id].color" style="text-transform: uppercase;">
                    {{ statusMap[item.status_id].name }}
                  </v-chip>
                </div>
              </td>
              <td class="text-right">
                <v-menu offset-y>
                  <template #activator="{ on, attrs }">
                    <v-btn class="ml-1 my-1" elevation="0" fab outlined x-small v-bind="attrs" tile color="primary" style="border-radius: 7px; width: 28px !important; height: 28px !important;" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pa-3">

                    <v-list-item @click="openAllocationForm(item.id)">
                      <v-list-item-title style="font-weight: 600; color: #1976D2">
                        OPEN
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="issueAllocation(item.id)" :disabled="item.is_issued === 1">
                      <v-list-item-title :style="`color: ${item.is_issued ? 'rgba(0,0,0,0.26)' : 'green'}; font-weight: 600;`">
                        ISSUE
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="undoIssueAllocation(item.id)" :disabled="item.status_id != 2">
                      <v-list-item-title :style="`color: ${item.status_id != 2 ? 'rgba(0,0,0,0.26)' : 'green'}; font-weight: 600;`">
                        UNDO ISSUE
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="generatePDF(item.id)">
                      <v-list-item-title style="font-weight: 600; color: #1976D2">
                        PDF
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="archiveAllocation(item)" :disabled="item.is_archived == 1">
                      <v-list-item-title :style="`color: ${item.is_archived == 1  ? 'rgba(0,0,0,0.26)' : 'purple'}; font-weight: 600;`">
                        ARCHIVE
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="unarchiveAllocation(item.id)" :disabled="item.is_archived == 0">
                      <v-list-item-title :style="`color: ${item.is_archived == 0  ? 'rgba(0,0,0,0.26)' : 'purple'}; font-weight: 600;`">
                        UNARCHIVE
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="deleteAllocation(item.id)" :disabled="item.is_issued === 1">
                      <v-list-item-title :style="`color: ${item.is_issued ? 'rgba(0,0,0,0.26)' : 'red'}; font-weight: 600;`">
                        DELETE
                      </v-list-item-title>
                    </v-list-item>

                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="showAllocationInitForm" max-width="33%" persistent>
      <inventory-allocation-init-form 
        @allocation-initialized="onAllocationInitialized"
        @close="showAllocationInitForm = false"
      />
    </v-dialog>

    <v-dialog v-model="showAllocationForm" fullscreen persistent>
      <inventory-allocation-form
        ref="allocationForm"
        @close="onClosedAllocationForm"
      />
    </v-dialog>

    <confirm-form ref="confirmForm" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import InventoryClassSelectElement from '@/components/elements/InventoryClassSelectElement.vue';
import InventoryAllocationInitForm from '@/components/forms/inventoryAllocation/InventoryAllocationInitForm.vue';
import InventoryAllocationForm from '@/components/forms/inventoryAllocation/InventoryAllocationForm.vue';
import * as allocationApi from '@/api/InventoryAllocationApi.js';
import * as FormatHelpers from '@/helpers/FormatHelpers';

export default {
  components: {
    InventoryClassSelectElement,
    InventoryAllocationInitForm,
    InventoryAllocationForm,
  },
  data: () => ({
    showAllocationInitForm: false,
    showAllocationForm: false,
    inventoryClassFilterId: null,
    categoryFilterId: null,
    jobFilterId: null,
    statusFilterId: null,
    showArchivedFilter: false,
    dateCreatedFilter: null,
    jobs: [],
    statuses: [],
    statusMap: {},
    loadingJobs: false,
    footer: {
      'items-per-page-options': [20, 50, 100, 500, 1000],
    },
    tableIsLoading: false,
    allocations: [],
    numberOfAllocations: 0,

    tableHeaders: [
      { text: 'ID', value: 'id' },
      { text: 'Class', value: 'inventory_class_id', class: 'text-center', sortable: false },
      { text: 'Release', value: 'job_id' },
      { text: 'QTY Required', value: 'qty_required' },
      { text: 'QTY Allocated', value: 'qty_allocated' },
      { text: 'QTY Supplied', value: 'qty_supplied' },
      { text: 'QTY Pre-Alloc.', value: 'qty_pre_allocated' },
      { text: 'Allocate By', value: 'allocate_by' },
      { text: 'Allocation %', value: 'allocation_percent' },
      { text: 'Pre-Alloc %', value: 'pre_alloc_percent' },
      { text: 'Created By', value: 'created_by' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Status', value: 'status_id', align: 'center' },
      { text: 'Actions', value: 'id', sortable: false },
    ],
    pagination: {
      page: 1,
      itemsPerPage: 25
    },
    sort: {
      sortBy: 'created_at',
      sortDirection: 'desc'
    },
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
  }),
    ...mapGetters([
      'businessRulesGetBoolean',
      'getAdminModuleValue',
    ]),
    isAuthorized() {
      return this.user.roles.some(x => x.name === 'Allocation Admin' || x.name === 'Admin');
    }
  },
  watch: {
    pagination() {
      if (!this.tableIsLoading) this.loadTableData();
    }, 
    sort() {
      if (!this.tableIsLoading) this.loadTableData();
    },
    search() {
      this.loadTableData();
    },
    inventoryClassFilterId() {
      this.loadTableData();
    },
    jobFilterId() {
      this.loadTableData();
    },
    statusFilterId() {
      this.loadTableData();
    },
    showArchivedFilter() {
      this.loadTableData();
    }
  },
  created() {
    if (!this.isAuthorized) this.$router.push('/');
    this.init();
  },
  methods: {
    async init() {
      if (!this.isAuthorized) return;
      Promise.all([
        this.$api.job.readDDL(),
        allocationApi.getStatuses(),
        this.loadTableData()
      ]).then(([jobs, statuses]) => {
        this.jobs = jobs;
        this.statuses = statuses;
        this.statusMap = statuses.reduce((acc, x) => {
          acc[x.id] = x;
          return acc;
        }, {});
      });
    },

    async loadTableData() {
      this.tableIsLoading = true;
      try {
        const data = {
          filters: {
            inventory_class_id: this.inventoryClassFilterId,
            job_id: this.jobFilterId,
            status_id: this.statusFilterId,
            date_created: this.dateCreatedFilter,
            category_id: this.categoryFilterId,
            show_archived: this.showArchivedFilter,
          },
          pagination: this.pagination,
          sort: this.sort,
          search: this.search
        };
        const res = await allocationApi.readForms(data);
        this.allocations = res.data;
        this.numberOfAllocations = res.total;
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', 'There was an error loading table data');
      } finally {
        this.tableIsLoading = false;
      }
    },

    openInitForm() {
      this.showAllocationInitForm = true;
    },

    onAllocationInitialized(allocationId) {
      console.log(allocationId)
      this.showAllocationInitForm = false;
      this.loadTableData();
      this.openAllocationForm(allocationId);
    },

    openAllocationForm(allocationId) {
      this.showAllocationForm = true;
      setTimeout(() => this.$refs.allocationForm.open(allocationId), 1000);
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        sortBy: newOptions.sortBy[0],
        sortDirection: newOptions.sortDesc[0],
      };
    },

    getRowBackgroundColor(row) {
    if (row.status_id === 2 || row.status_id === 5 || row.status_id === 6 || row.status_id === 7 || row.status_id === 9) return '';
      const allocationPercent = 100 * row.qty_allocated  / row.qty_required;
      if (row.allocate_by_date !== null) {
        if (allocationPercent <= 20) return '#f4cccc';
        if (allocationPercent < 90) return '#FFFDE7';
      }
      return '';
    },

    formatPercent(value, isDecimal = true) {
      if (value === null || value === undefined || isNaN(value)) return '-';
      if (typeof(value) === 'string') value = Number(value);
      if (isDecimal) value *= 100;
      return `${Math.round(value)}%`;
    },

    async deleteAllocation(allocationId) {
      try {
        const confirm = await this.$refs.confirmForm.open({
          title: 'Are you sure that you want to delete this Allocation?',
        });
        if (!confirm) return;
        const res = await allocationApi.deleteAllocation(allocationId);
        if (res !== true) throw new Error();
        this.$bus.$emit('showSuccess', 'The allocation has been deleted');
        this.loadTableData();
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', e.response?.data || `Failed to delete Allocation.`);
      }
    },

    async issueAllocation(allocationId) {
      try {
        const confirm = await this.$refs.confirmForm.open({
          title: 'Are you sure that you want to issue this Allocation?',
        });
        if (!confirm) return;

        const res = await allocationApi.issueAllocation(allocationId);
        if (res !== true) throw new Error();
        this.$bus.$emit('showSuccess', 'The allocation has been issued');
        this.loadTableData();
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', e.response?.data || `Failed to issue Allocation.`);
      }
    },

    async undoIssueAllocation(allocationId) {
      try {
        const confirm = await this.$refs.confirmForm.open({
          title: 'Are you sure that you want to undo issue this Allocation?',
        });
        if (!confirm) return;

        const res = await allocationApi.undoIssueAllocation(allocationId);
        if (res !== true) throw new Error();
        this.$bus.$emit('showSuccess', 'The allocation has been unissued');
        this.loadTableData();
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', e.response?.data || `Failed to unissue Allocation.`);
      }
    },

    async archiveAllocation(allocation) {
      try {
        const hasQtyToRelease = await allocationApi.hasUnreleasedQty(allocation.id);
        if (hasQtyToRelease) {
          this.$refs.confirmForm.open({
            title: `This Allocation has unreleased allocated materials. Please release them before archiving`,
            showConfirmBtn: false,
            header: 'Archive'
          });
        } else {
          const confirm = await this.$refs.confirmForm.open({
            title: `Are you sure that you want to archive this Allocation?`,
            header: 'Archive'
          });
          if (!confirm) return;

          const res = await allocationApi.archiveAllocation(allocation.id);
          if (res !== true) throw new Error();
          this.$bus.$emit('showSuccess', 'The allocation has been archived');
          this.loadTableData();
        }
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', e.response?.data || `Failed to archive Allocation.`);
      }
    },

    async unarchiveAllocation(allocationId) {
      try {
        const confirm = await this.$refs.confirmForm.open({
          title: 'Are you sure that you want to archive this Allocation?',
        });
        if (!confirm) return;

        const res = await allocationApi.unarchiveAllocation(allocationId);
        if (res !== true) throw new Error();
        this.$bus.$emit('showSuccess', 'The allocation has been unarchived');
        this.loadTableData();
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', e.response?.data || `Failed to unarchive Allocation.`);
      }
    },

    onClosedAllocationForm() {
      this.showAllocationForm = false;
      this.loadTableData();
    },

    async generatePDF(allocationId) {
      try {
        const data = {
          module_id: 66,
          allocation_id: allocationId,
        };
        const res = await this.$api.webhook.store(data, 'run-download', { responseType: 'blob' });
        const blobUrl = URL.createObjectURL(res);
        const aEl = document.createElement('a')
        aEl.href = blobUrl;
        const now = FormatHelpers.getFileTimestamp();
        aEl.download = `allocation_${allocationId}_${now}.pdf`;
        aEl.click();
        URL.revokeObjectURL(blobUrl)
        this.$bus.$emit('showSuccess', 'PDF generated successfully');
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', 'Failed to generate the PDF');
      }
    }
  },
};
</script>